<template>
  <el-footer class="custom-footer">
    <div class="footer-content">
      <div class="links-area">
        <p class="friend-links">
          友情链接:
          <a href="#" class="link-item">在线课堂</a>
          <a href="#" class="link-item">B站视频</a>
          <a href="#" class="link-item">抖音视频</a>
          <a href="#" class="link-item">小红书</a>
        </p>
      </div>

      <div class="copyright-area">
        <p class="copyright-text">
          版权所有 © 智学堂
          <span class="record-info">备案: <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2026053962号-1</a></span>

        </p>
      </div>
    </div>
  </el-footer>
</template>

<script setup>

</script>

<style scoped>
.custom-footer {
  background-color: #2a2a2a;
  color: #cccccc;
  padding: 20px 0;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.links-area {
  margin-bottom: 10px;
}

.friend-links {
  font-size: 14px;
}

.link-item {
  color: #cccccc;
  text-decoration: none;
  margin: 0 8px;
  transition: color 0.3s ease;
}

.link-item:hover {
  color: #ffffff;
}

.copyright-area {
  font-size: 13px;
  text-align: center;
}

.copyright-text {
  margin: 0;
  line-height: 1.6;
}

.record-info,
.license-info {
  margin-left: 15px;
}

/* 响应式调整 */
@media (min-width: 768px) {
  .footer-content {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .links-area {
    margin-bottom: 0;
  }

  .copyright-area {
    text-align: left;
  }
}
</style>
